import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import { useToast } from './components/base/Toast';
import i18n from './i18n';
import { HelmetProvider } from 'react-helmet-async'; // YENİ EKLENDİ
import { SEO } from './components/SEO'; // YENİ EKLENDİ

function App() {
  const { ToastContainer } = useToast();

  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <SEO /> {/* İŞTE BU EKSİKTİ! */}
          <AppRoutes />
          <ToastContainer />
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  );
}

export default App;